export default "__VITE_ASSET__0b4d805f__"